import View from './view';
export const PollsTable = View;
